function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M72,496H368a111.991,111.991,0,0,0,48-213.179V120a8,8,0,0,0-2.343-5.657l-96-96A8,8,0,0,0,312,16H72A40.045,40.045,0,0,0,32,56V456A40.045,40.045,0,0,0,72,496ZM464,384a96,96,0,1,1-96-96A96.108,96.108,0,0,1,464,384ZM320,43.313,388.687,112H344a24.027,24.027,0,0,1-24-24ZM48,56A24.028,24.028,0,0,1,72,32H304V88a40.045,40.045,0,0,0,40,40h56V276.666A111.983,111.983,0,0,0,310.369,480H72a24.028,24.028,0,0,1-24-24Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M160,168a8,8,0,0,0,8,8H360a8,8,0,0,0,0-16H168A8,8,0,0,0,160,168Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M88,224H248a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M280,256H216a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M88,320H232a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M88,176h48a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M360,208H280a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M88,272h96a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M216,400H184a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M88,416h64a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M88,368h48a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M88,128h96a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M216,352H168a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M325.657,402.343a8,8,0,0,0-11.314,11.314l32,32A8,8,0,0,0,352,448q.394,0,.789-.039a8,8,0,0,0,5.868-3.523l64-96a8,8,0,0,0-13.312-8.876l-58.587,87.881Z"
});

var SvgComplete = function SvgComplete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filled",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M376,488H72a32,32,0,0,1-32-32V56A32,32,0,0,1,72,24H312l96,96V456A32,32,0,0,1,376,488Z",
    style: {
      fill: "#e9eef2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,120H344a32,32,0,0,1-32-32V24Z",
    style: {
      fill: "#c3c6c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 384,
    r: 104,
    style: {
      fill: "#75ab7d"
    }
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComplete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/complete.905b5b5f.svg";
export { ForwardRef as ReactComponent };